const MenuSuperAdmin = [
  {
    heading: "Akongo Animal Welfare Monitor",
  },

  {
    name: "Centre de pilotage",
    icon: "fa fa-tachometer-alt",
    path: "DashboardNext",
    translate: "sidebar.nav.DASHBOARD",
  },
  {
    name: "Mes rappels",
    icon: "fa fa-stopwatch",
    path: "MyActivitiesView",
    translate: "sidebar.nav.MY_REMINDERS",
  },
  {
    name: "Gestion des tâches",
    icon: "fa fa-tasks",
    path: "TaskManagementView",
    translate: "sidebar.nav.TASK_MANAGEMENT",
  },
  {
    name: "Vue Live",
    icon: "fa fa-broadcast-tower",
    path: "LiveSectorView",
    translate: "sidebar.nav.LIVE_VIEW",
  },
  {
    name: "Timeline",
    icon: "fa fa-stream",
    path: "Timeline",
    translate: "sidebar.nav.TIMELINE",
  },

  {
    heading: "Accompagnement AKONGO",
  },

  {
    name: "Gestion des campagnes",
    icon: "fa fa-file-alt",
    path: "ReportListView",
    translate: "sidebar.nav.REPORT",
  },

  {
    heading: "Gestion du parc",
    translate: "sidebar.heading.PARC_MANAGEMENT",
  },
  {
    name: "Gestion des secteurs",
    icon: "fa fa-map-marked-alt",
    path: "SectorListView",
    translate: "sidebar.nav.SECTOR_MANAGEMENT",
  },
  {
    name: "Gestion des enclos",
    icon: "fa fa-th-large",
    path: "EnclosureListView",
    translate: "sidebar.nav.ENCLOSURE_MANAGEMENT",
  },
  {
    name: "Gestion des individus",
    icon: "fa fa-paw",
    translate: "sidebar.nav.ANIMAL_MANAGEMENT",
    path: "specieAnimalsListView",
  },
  {
    name: "Gestion des groupes",
    icon: "fa fa-layer-group",
    translate: "sidebar.nav.GROUP_MANAGEMENT",
    path: "GroupListView",
  },
  {
    name: "Gestion des enrichissements",
    icon: "fa fa-gift",
    path: "EnrichListView",
    translate: "sidebar.nav.ENRICHMENT_MANAGEMENT",
  },

  {
    heading: "Données BEA",
    translate: "sidebar.heading.BEA_DATA",
  },

  {
    name: "Gestion des campagnes",
    icon: "fa fa-bullhorn",
    path: "CampaignListView",
    translate: "sidebar.nav.CAMPAIGN_MANAGEMENT",
  },
  {
    name: "Historique collectes",
    icon: "fa fa-history",
    path: "EvalHistory",
    translate: "sidebar.nav.HISTORY",
  },
  {
    name: "Grilles d'évaluation",
    icon: "fa fa-bolt",
    path: "FastEvalGroupListView",
    translate: "sidebar.nav.FAST_EVALUATION",
  },
  {
    name: "Consulter les évaluations",
    icon: "fa fa-clipboard-check",
    path: "CampaignQuizzMonitoringView",
    translate: "sidebar.nav.EVALUATION_MONITORING",
  },
  {
    name: "Bilan d'Activité",
    icon: "fa fa-chart-line",
    path: "cirManagementView",
    translate: "sidebar.nav.BILAN",
  },

  {
    heading: "Ressources",
    translate: "sidebar.heading.RESSOURCES",
  },

  {
    name: "Consulter les questionnaires",
    icon: "fa fa-question-circle",
    path: "QuizzListViewReadOnly",
    translate: "sidebar.nav.QUIZZ_MONITORING",
  },

  {
    name: "Consulter les éthogrammes",
    icon: "fa fa-list",
    path: "obsListViewReadOnly",
    translate: "sidebar.nav.ETHO_MONITORING",
  },

  {
    heading: "Mon compte AWM",
    translate: "sidebar.heading.MY_ACCOUNT",
  },
  {
    name: "Gérer mon compte",
    icon: "fa fa-user-circle",
    translate: "sidebar.nav.USER_SETTINGS",
    path: "userSettings",
  },
  {
    name: "Inviter des utilisateurs",
    icon: "fa fa-user-plus",
    translate: "sidebar.nav.USER_CREATION",
    path: "userCreation",
  },

  {
    heading: "Administration AWM",
    translate: "sidebar.heading.ADMINISTRATION",
  },
  {
    name: "Gestion des établissements",
    icon: "fa fa-building",
    translate: "sidebar.nav.ESTABLISHMENT_MANAGEMENT",
    path: "ZooList",
  },
  {
    name: "Réglages Admin",
    icon: "fa fa-sliders-h",
    translate: "sidebar.nav.ADMIN_SETTINGS",
    path: "AdminSettings",
  },
  {
    name: "Discovery Analytics",
    icon: "fa fa-chart-line",
    translate: "sidebar.nav.DISCOVERY_ANALYTICS",
    path: "DiscoveryAnalytics",
  },
  {
    name: "Projets de recherche",
    icon: "fa fa-flask",
    translate: "sidebar.nav.PROJECT_MANAGEMENT",
    path: "ResearchListView",
  },

  {
    name: "Gestion des questionnaires",
    icon: "fa fa-list-alt",
    translate: "sidebar.nav.GESTION_QUESTIONNAIRES",
    submenu: [
      {
        name: "Gestion des Questionnaires",
        translate: "sidebar.nav.GESTION_QUESTIONNAIRES_VIEW",
        path: "quizzListView3",
      },

      {
        name: "Gestion Questions",
        translate: "sidebar.nav.GESTION_QUESTIONS_VIEW",
        path: "QuestionListView",
      },
      {
        name: "Gestion Profils",
        translate: "sidebar.nav.GESTION_PROFILS_VIEW",
        path: "QuizzProfileView",
      },
      {
        name: "(old) Questionnaires",
        translate: "sidebar.nav.GESTION_QUESTIONNAIRES_VIEW_OLD",
        path: "quizzListView2",
      },
    ],
  },
  {
    name: "Gestion des observations",
    icon: "fa fa-binoculars",
    translate: "sidebar.nav.OBSERVATION_MANAGEMENT",
    submenu: [
      // {
      //   name: "Séquences d'obs",
      //   translate: "sidebar.nav.SUBMENU",
      //   path: "ObsSessionListView",
      // },
      {
        name: "Ethogrammes",
        translate: "sidebar.nav.ETHOGRAMME",
        path: "ObsListView",
      },
      {
        name: "Contextes",
        translate: "sidebar.nav.CONTEXTE",
        path: "ObsContextListView",
      },
    ],
  },
  {
    name: "Paramétrage AWM",
    icon: "fa fa-cog",
    translate: "sidebar.nav.AWM_SETTINGS",
    submenu: [
      {
        name: "Tags d'enrichissement",
        translate: "sidebar.nav.TAG_MANAGEMENT_GLOBAL",
        path: "TagManagementView",
      },
      {
        name: "Tags des documents",
        translate: "sidebar.nav.DOCUMENT_TAGS_MANAGEMENT",
        path: "DocumentTagsManagementView",
      },
    ],
  },

  {
    name: "Gestion des taxons",
    icon: "fa fa-dna",
    translate: "sidebar.nav.TAXON_MANAGEMENT",
    submenu: [
      {
        name: "Base ordres",
        path: "/OrderListManagement",
        translate: "sidebar.nav.ORDER_MANAGEMENT",
      },
      {
        name: "Base familles",
        path: "/FamilyListManagement",
        translate: "sidebar.nav.FAMILY_MANAGEMENT",
      },
      {
        name: "Base espèces",
        path: "/SpecieListManagement",
        translate: "sidebar.nav.ESPECE_MANAGEMENT",
      },
      {
        name: "Recherche IUCN",
        path: "/IUCNSpeciesSearch",
        translate: "sidebar.nav.IUCN_SPECIES_SEARCH",
      },
    ],
  },
];

export default MenuSuperAdmin;
